import {createActions} from 'client/framework';

const drawerActionsList = ['DRAWER_RESET_STORE', 'DRAWER_SET_DRAWER_VISIBILITY'];

export const drawerActions = createActions(null, drawerActionsList);
